import type { BlogPost, BlogVideo } from './blog-types';
import { BLOG_VIDEO_YOUTUBE_IDS } from './blog-youtube';

export const BLOG_VIDEOS: BlogVideo[] = [
  {
    key: 'product',
    category: 'PRODUCT',
    duration: '2:48',
    guideHref: '/blog/guide-product',
    thumbnail: '/commerce/static/intro/blog/en/yt-thumbs/product.png',
    youtubeId: BLOG_VIDEO_YOUTUBE_IDS.en.product,
    title: 'Product management',
    summary:
      'See the full flow of registering product information and uploading images at a glance.',
  },
  {
    key: 'detail',
    category: 'PDP',
    duration: '9:51',
    guideHref: '/blog/guide-detail-create',
    thumbnail: '/commerce/static/intro/blog/en/yt-thumbs/detail.png',
    youtubeId: BLOG_VIDEO_YOUTUBE_IDS.en.detail,
    title: 'Product page creation',
    summary:
      'A walkthrough of generating a product page and editing it with your own text and images.',
  },
  {
    key: 'banner',
    category: 'BANNER',
    duration: '4:30',
    guideHref: '/blog/guide-banner',
    thumbnail: '/commerce/static/intro/blog/en/yt-thumbs/banner.png',
    youtubeId: BLOG_VIDEO_YOUTUBE_IDS.en.banner,
    title: 'Banner creation',
    summary:
      'Covers the basic flow of creating banners and promotional visuals.',
  },
  {
    key: 'video',
    category: 'VIDEO',
    duration: '3:58',
    guideHref: '/blog/guide-video',
    thumbnail: '/commerce/static/intro/blog/en/yt-thumbs/video.png',
    youtubeId: BLOG_VIDEO_YOUTUBE_IDS.en.video,
    title: 'Video creation',
    summary: 'Learn how to quickly showcase features with short videos.',
  },
  {
    key: 'ai-studio',
    category: 'AI STUDIO',
    duration: '4:30',
    guideHref: '/blog/guide-ai-studio',
    thumbnail: '/commerce/static/intro/blog/en/yt-thumbs/ai-studio.png',
    youtubeId: BLOG_VIDEO_YOUTUBE_IDS.en['ai-studio'],
    title: 'AI Studio',
    summary:
      'Introduces the main flow of generating AI images and using the recommended results.',
  },
];

export const BLOG_POSTS: BlogPost[] = [
  {
    id: 18,
    slug: 'release-2026-07-09',
    categoryKey: 'release',
    date: '2026.07.09',
    image: '',
    title: 'Update on 2026.07.09',
    description:
      'VAETKI Commerce has been updated with multilingual support and enhanced editor tools.',
  },
  {
    id: 2,
    slug: 'release',
    categoryKey: 'release',
    date: '2026.05.20',
    image: '/commerce/static/intro/blog/en/thumbs/thumb-release.svg',
    title: 'Official launch on 2026.05.20',
    description:
      'VAETKI Commerce has officially launched. Here are the features available in this release.',
  },
  {
    id: 3,
    slug: 'notice',
    categoryKey: 'notice',
    date: '2026.05.20',
    image: '/commerce/static/intro/blog/en/thumbs/thumb-notice.svg',
    title: 'VAETKI Commerce official launch',
    description:
      'From a single image to product pages, videos, and banners — VAETKI Commerce officially opens its doors.',
  },
  {
    id: 14,
    slug: 'faq-etc',
    categoryKey: 'faq',
    date: '2026.05.20',
    image: '/assets/faq-etc.svg',
    title: 'Other FAQs',
    description:
      'A collection of other frequently asked questions about copyright, commercial use, external platforms, enterprise inquiries, and more.',
  },
  {
    id: 13,
    slug: 'faq-payment',
    categoryKey: 'faq',
    date: '2026.05.20',
    image: '/assets/faq-payment.svg',
    title: 'Payment & refund FAQ',
    description:
      'A collection of frequently asked questions about credit purchases, payment methods, refund policies, and more.',
  },
  {
    id: 6,
    slug: 'faq-ai',
    categoryKey: 'faq',
    date: '2026.05.20',
    image: '/assets/faq-ai.svg',
    title: 'AI features FAQ',
    description:
      'A collection of frequently asked questions about AI Studio and AI CHAT features.',
  },
  {
    id: 5,
    slug: 'faq-service-page',
    categoryKey: 'faq',
    date: '2026.05.20',
    image: '/assets/faq-service-page.svg',
    title: 'Service usage FAQ',
    description:
      'A collection of frequently asked questions about using the service, including product page generation, video creation, banner creation, and AI Studio.',
  },
  {
    id: 4,
    slug: 'faq-account',
    categoryKey: 'faq',
    date: '2026.05.20',
    image: '/assets/faq-account.svg',
    title: 'Account & login FAQ',
    description:
      'A collection of frequently asked questions about sign-up and login.',
  },
  {
    id: 12,
    slug: 'guide-ai-studio',
    categoryKey: 'guide',
    date: '2026.05.20',
    image: '/commerce/static/intro/blog/en/thumbs/thumb-guide-ai.svg',
    title: 'AI Studio guide',
    description:
      'Learn how to use basic editing, style presets, and inpainting in AI Studio.',
  },
  {
    id: 11,
    slug: 'guide-video',
    categoryKey: 'guide',
    date: '2026.05.20',
    image: '/commerce/static/intro/blog/en/thumbs/thumb-guide-video.svg',
    title: 'Video creation guide',
    description:
      'A guide to the full flow of creating videos from product images, then downloading and managing them.',
  },
  {
    id: 17,
    slug: 'guide-banner',
    categoryKey: 'guide',
    date: '2026.05.20',
    image: '/commerce/static/intro/blog/en/thumbs/thumb-guide-banner.svg',
    title: 'Banner creation guide',
    description:
      'A guide to the full flow of creating a banner from a new project, then editing and exporting it.',
  },
  {
    id: 15,
    slug: 'guide-detail-create',
    categoryKey: 'guide',
    date: '2026.05.20',
    image: '/commerce/static/intro/blog/en/thumbs/thumb-guide-detail.svg',
    title: 'Product page creation guide',
    description:
      'A guide to the entire product page creation process, from entering product information to editing, AI edits, and exporting.',
  },
  {
    id: 1,
    slug: 'guide-product',
    categoryKey: 'guide',
    date: '2026.05.20',
    image: '/commerce/static/intro/blog/en/thumbs/thumb-guide-product.svg',
    title: 'Product management guide',
    description:
      'Learn how to register products in the product list and track work progress with indicators.',
  },
];
